import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { LocalStorageService } from "src/app/utils/localstorage.service";
import { environment } from "../../../../environments/environment";
import { Observable, Subject } from "rxjs";

@Injectable()
export class TrackedItemsDashboardService {
  show_loading = new Subject<any>();

  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService,
    private router: Router,
  ) {}

  get_tracked_items(
    timeframe: string,
    status: string,
    client: string,
    workspace_tags: [] = [],
    andOrWorkspaces: string = null,
    first = null,
    rows = null,
  ): Promise<any> {
    let params = "";

    if (andOrWorkspaces) {
      params = params + `&and_or_workspaces=${andOrWorkspaces}`;
    }
    let workspace_tag_uuids = workspace_tags
      .map((tag: any) => tag.uuid)
      .join(",");

    params = params + `&workspace_tags=${workspace_tag_uuids}`;

    return this.http
      .get(
        `${environment.apiUrl}/conversations/tracked-items?timeframe=${timeframe}&status=${status}&client=${client}&rows=${rows}&start=${first}${params}`,
      )
      .toPromise();
  }
}
